import { flushSync } from 'react-dom';
import { standardRequestWithErrorFlash } from '../../../shared/utils/request';
import type { Dispatch, State } from '../use_candidate_profile';
import type { ScorecardData } from '../../shared/types';

type GetScorecardsAction = {
  type: 'getScorecards';
  payload: ScorecardData;
};

export const getScorecardsForApplication =
  (state: State, dispatch: Dispatch) => async () => {
    try {
      flushSync(() => {
        dispatch({
          type: 'setStatus',
          payload: { key: 'scorecard', type: 'loading' },
        });
      });
      const result = await standardRequestWithErrorFlash.get(
        state.paths.applicationScorecardsPath
      );
      dispatch({
        type: 'getScorecards',
        payload: result.data,
      });
      dispatch({
        type: 'setStatus',
        payload: { key: 'scorecard', type: 'complete' },
      });
    } catch (e) {
      dispatch({
        type: 'setStatus',
        payload: { key: 'scorecard', type: 'error', context: e },
      });
    }
  };

export type Actions = GetScorecardsAction;
